import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  Button,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import AutoCompleteListFormik from "components/AutoCompleteListFormik";
import CustomDialog from "components/CustomDialog";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDistributorThunk } from "store/reducers/accounts";
import { locationStockTransactionThunk, resetStat } from "store/reducers/inventory/stock/locationStockSlice";
import * as yup from "yup";

const RemoveLocationStock = ({ open, handleClose, stock }) => {
  const dispatch = useDispatch();
  const validation = yup.object({
    qty: yup.number().required().positive().min(1).max(stock.qty),
  });
  const formik = useFormik({
    initialValues: {
      qty: stock.qty,
      product_variant: stock.product_variant,
      in_or_out: "rem",
      return_reason: "dam",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      const newData = { ...data, location:stock.location };
      console.log(newData);
      dispatch(locationStockTransactionThunk({ stock, data: newData }));
    },
    enableReinitialize: true,
  });
  const state = useSelector(
    (state) => state.locationStock.locationStockTransactionStatus
  );


  useEffect(() => {
    dispatch(getDistributorThunk());
  }, []);
  useEffect(()=>{
    dispatch(resetStat())
  },[])
  
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Return stock"
    >
      <Box padding={2}>
        <Typography variant="h6" color="text.secondary">
          You are about to return the following product
        </Typography>
        <Typography variant="h5" color="text.secondary">
          {stock.name}
        </Typography>
        <form onSubmit={formik.handleSubmit} style={{ marginTop: 2 }}>
          <TextField
            fullWidth
            name="qty"
            value={formik.values.qty}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.qty)}
            helperText={formik.errors.qty}
            type="number"
            sx={{ marginBottom: 2 }}
          />

          <TextField
            label="Choose Reason"
            variant="outlined"
            name="return_reason"
            select
            fullWidth
            sx={{ mt: 3 }}
            value={formik.values.return_reason}
            onChange={formik.handleChange("return_reason")}
            error={Boolean(formik.errors.return_reason)}
            helperText={formik.errors.return_reason}
            autoComplete="new-password"
          >
            <MenuItem value={"dam"}>Damaged</MenuItem>
            <MenuItem value={"exp"}>Expired</MenuItem>
            <MenuItem value={"qlt"}>Quality Issue</MenuItem>
          </TextField>

          {state?.error === "post" && (
            <Alert sx={{ my: 1 }} severity="error">
              Error occurred , {state?.errorMessage}
            </Alert>
          )}

          {state?.success === "post" && (
            <Alert sx={{ my: 1 }} severity="success">
              Success
            </Alert>
          )}
          <LoadingButton
            sx={{ mt: 2 }}
            variant="outlined"
            type="submit"
            loading={state?.loading === "post"}
          >
            Submit
          </LoadingButton>
        </form>
      </Box>
    </CustomDialog>
  );
};

export default RemoveLocationStock;
